import { Nota, Vazio } from '../ui/primitivos.jsx';

/**
 * O lugar de cada tela que ainda não existe.
 *
 * O documento 05 entrega a FUNDAÇÃO — tokens, componentes, shell,
 * login. As telas de módulo são de cada documento seguinte, e este
 * marcador diz qual, em vez de deixar uma rota morta que ninguém sabe
 * de quem é.
 */
export function EmBreve({ titulo, documento }: { titulo: string; documento: string }) {
  return (
    <>
      <div className="page-head">
        <div>
          <h1>{titulo}</h1>
          <p>Esta tela ainda não foi construída.</p>
        </div>
      </div>

      <Nota>
        A fundação do front — tokens, componentes, shell e login — é o documento 05. Esta tela chega
        no <b>documento {documento}</b> do plano.
      </Nota>

      <Vazio>Nada para mostrar ainda.</Vazio>
    </>
  );
}
